
import { Server, Building, Globe, Headphones } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const ServicesSection = () => {
  const navigate = useNavigate();

  const services = [
    {
      icon: Server,
      title: 'Servers',
      description: 'High-performance dedicated servers with SSD storage and instant deployment.',
      pricing: 'Starting @ $9.99/month',
      href: '/baremetal-servers'
    },
    {
      icon: Building,
      title: 'Colocation',
      description: 'Secure cabinet space with redundant power, smart hands, and 24/7 access.',
      pricing: 'Starting @ $39/month',
      href: 'https://ncolo.net',
      isMovingToNcolo: true
    },
    {
      icon: Globe,
      title: 'Residential Proxies',
      description: 'Rotating IP addresses for SEO, automation, and data collection needs.',
      pricing: 'Starting @ $0.40/month',
      href: '/residential-proxies'
    },
    {
      icon: Headphones,
      title: 'Consultation',
      description: 'Strategic advisory services for SMBs to Enterprise infrastructure planning.',
      pricing: 'Starting @ $1,990/one-time',
      href: '/consultation'
    }
  ];

  const handleServiceClick = (service: typeof services[0]) => {
    if (service.href.startsWith('http')) {
      window.open(service.href, '_blank');
    } else {
      navigate(service.href);
    }
  };

  return (
    <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
      {services.map((service, index) => (
        <div
          key={service.title}
          onClick={() => handleServiceClick(service)}
          className={`group bg-white/90 backdrop-blur-sm border border-gray-200/50 rounded-2xl transition-all duration-300 hover:-translate-y-1 overflow-hidden flex flex-col animate-fade-in cursor-pointer ${
            service.isMovingToNcolo 
              ? 'hover:border-blue-500 hover:shadow-xl hover:shadow-blue-500/25 hover:ring-2 hover:ring-blue-500/20' 
              : 'hover:border-nexx-green hover:shadow-xl'
          }`}
          style={{ animationDelay: `${index * 100}ms` }}
        >
          <div className="p-6 flex-1">
            <div className="mb-4">
              <div className={`w-12 h-12 bg-green-50 rounded-xl flex items-center justify-center group-hover:scale-110 transition-all duration-300 ${
                service.isMovingToNcolo 
                  ? 'group-hover:bg-blue-600' 
                  : 'group-hover:bg-nexx-green'
              }`}>
                <service.icon className={`h-6 w-6 transition-colors duration-300 ${
                  service.isMovingToNcolo 
                    ? 'text-nexx-green group-hover:text-white' 
                    : 'text-nexx-green group-hover:text-white'
                }`} />
              </div>
            </div>
            <h3 className={`text-lg font-semibold text-gray-900 mb-2 transition-colors duration-300 ${
              service.isMovingToNcolo 
                ? 'group-hover:text-blue-600' 
                : 'group-hover:text-nexx-green'
            }`}>
              {service.title}
            </h3>
            <p className="text-sm text-gray-600 leading-relaxed mb-3">
              {service.description}
            </p>
            <p className={`text-base font-bold transition-colors duration-300 ${
              service.isMovingToNcolo 
                ? 'text-nexx-green group-hover:text-blue-600' 
                : 'text-nexx-green'
            }`}>
              {service.pricing}
            </p>
          </div>
          
          {service.isMovingToNcolo && (
            <div className="bg-blue-600 text-white px-4 py-2 text-center">
              <p className="text-xs font-medium">Powered by NCOLO</p>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default ServicesSection;
